import {
  ActionIcon,
  Badge,
  Box,
  Button,
  ComboboxItem,
  Fieldset,
  Flex,
  Grid,
  Group,
  LoadingOverlay,
  Select,
  Tabs,
  Text,
  TextInput,
  Title,
} from "@mantine/core";
import { DateTimePicker } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  IconArrowBack,
  IconCheck,
  IconMapPin,
  IconSend,
  IconUser,
  IconUserQuestion,
} from "@tabler/icons-react";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { repositoryMdm, repositoryPos } from "../../../_base/_const/_constVar";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { getValueById } from "../../../_base/helper/FunctionHelper";
import { MessageResponse } from "../../../model/MessageResponse";
import { TblWarrantyItem } from "../../../model/TblWarrantyItem";
import { TblWarrantyServiceRequestForm } from "../../../model/TblWarrantyServiceRequestForm";
import {
  getCommuneSelectNew,
  getProvinceSelectNew,
  getTblDmProcessingMethodSelect,
  getTblDmSaleChanelSelect,
} from "../../../service/getSelectApi";
import { normalizeZnsPhoneNumber } from "../../../service/znsService";
import CustMeeting from "./CustMeeting";
import ItemList from "./ItemList";
import ListCustMeetingInfomation, {
  TblWarrantyReceipt,
} from "./ListCustMeetingInfomation";
import WarrantyItem from "./WarrantyItemList";

const CreateDataView = ({ onClose, onSuccess }: CreateDataViewProps) => {
  const entity = {
    id: 0,
    custId: 0,
    deliveryId: 0,
    branchId: null,
    inventoryId: null,
    requestStatus: null,
    deliveryDept: null,
    deliveryDate: null,
    custMeeting: null,
    meetingDate: null,
    custPhone: null,
    provinceId: null,
    communeId: null,
    districtId: null,
    streetId: null,
    additionalAddress: null,
    meetingAddress: null,
    processingMethod: null,
    processingMethodName: null,
    employeeIncharge: null,
    requestNum: "",
    note: null,
    vendorId: null,
    message: null,
    address: null,
    priorityId: null,
    warrantyStatus: null,
    locationId: null,
    channel: "67",
    channelName: null,
    employeeSupport: null,
    content: null,
    noteAssignRequest: null,
    receiveBranch: null,
    assignDate: null,
    empAssign: null,
    isReceive: false,
    customerGroup: null,
    attribute10: null,
    createDate: new Date()?.toISOString(),
    tblWarrantyServiceRequestFormDetailCommands: [],
  };

  const [visible, { toggle, close, open }] = useDisclosure(false);

  const [dataWarrantyItem, setDataWarrantyItem] = useState<TblWarrantyItem[]>(
    [],
  );
  const [dataWarrantyItemSubmit, setDataWarrantyItemSubmit] = useState<any[]>(
    [],
  );
  const [dataTblProcessingMethod, setDataTblProcessingMethod] = useState<
    ComboboxItem[]
  >([]);
  const [dataWarrantyCustomerGroup, setDataWarrantyCustomerGroup] =
    useState<any>([]);
  const [dataTblSaleChannel, setDataTblSaleChannel] = useState<ComboboxItem[]>(
    [],
  );

  const [oldAddress, setOldAddress] = useState<string | null>(null);
  const [dataMeetingAddress, setDataMeetingAddress] = useState<any>({
    custMeeting: null,
    province: null,
    commune: null,
    additionalAddress: null,
    custPhone: null,
  });
  const [dataProvinceSelect, setDataProvinceSelect] = useState<ComboboxItem[]>(
    [],
  );
  const [dataCommuneSelect, setDataCommuneSelect] = useState<ComboboxItem[]>(
    [],
  );
  const [handleOnChangeNumber, setHandleOnChangeNumber] = useState<string>("");
  const form = useForm<TblWarrantyServiceRequestForm>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    clearInputErrorOnChange: false,
    initialValues: {
      ...entity,
    },

    transformValues: (values) => ({
      ...values,
      meetingDate: new Date(
        new Date(values.meetingDate ?? "").getTime() + 7 * 60 * 60 * 1000,
      ).toISOString(),
      createDate: new Date(
        new Date(values.createDate ?? "").getTime() + 7 * 60 * 60 * 1000,
      ).toISOString(),
    }),
    // onValuesChange: (values) => {
    //   handleOnChange(values.custPhone, "custPhone");
    // },
    validate: {
      custMeeting(value, values, path) {
        if (!value) return "Vui lòng nhập người hẹn gặp!";
      },
      custPhone(value, values, path) {
        if (!value) {
          return "Vui lòng nhập số điện thoại !";
        }

        if (value && value.length < 8) {
          return "Số điện thoại không hợp lệ !";
        }
      },
      channel(value, values, path) {
        if (!value) return "Vui lòng chọn kênh tiếp nhận!";
      },
      customerGroup(value, values, path) {
        if (!value) return "Vui lòng chọn nhóm khách hàng!";
      },
      provinceId(value, values, path) {
        if (!value) return "Vui lòng chọn tỉnh/thành phố!";
      },
      communeId(value, values, path) {
        if (!value) return "Vui lòng chọn phường/xã!";
      },
      processingMethod(value, values, path) {
        if (!value) return "Vui lòng chọn hình thức xử lý!";
      },
      meetingDate(value) {
        if (!value) return "Vui lòng chọn ngày hẹn gặp!";
      },
    },
  });

  const isPhoneInvalid =
    !handleOnChangeNumber ||
    handleOnChangeNumber.length < 9 ||
    handleOnChangeNumber.length > 11;

  const handleOnChange = (value: any, key: string) => {
    if (value !== "Invalid date")
      setDataMeetingAddress((prevData: any) => ({ ...prevData, [key]: value }));
    else {
      setDataMeetingAddress((prevData: any) => ({ ...prevData, [key]: "" }));
    }
  };

  const processingMethodSelect = async () => {
    try {
      const getData = await getTblDmProcessingMethodSelect();
      const filteredData = getData?.filter(
        (item) => item.value != null && item.text != null,
      );
      const mappedData = filteredData?.map((item) => ({
        value: item.value,
        label: item.text,
      }));
      setDataTblProcessingMethod(mappedData);
    } catch (error) {
      console.error("Error in dataTblLocation: ", error);
    }
  };

  const saleChannelSelect = async () => {
    try {
      const getData = await getTblDmSaleChanelSelect();
      const filteredData = getData?.filter(
        (item) => item.value != null && item.text != null,
      );
      const mappedData = filteredData?.map((item) => ({
        value: item.value,
        label: item.text,
      }));
      setDataTblSaleChannel(mappedData);
    } catch (error) {
      console.error("Error in dataTblLocation: ", error);
    }
  };

  const getDataWarrantyCustomerGroup = async () => {
    const res = await repositoryMdm.get<MessageResponse<any>>(
      "/api/v1/TblWarrantyCustomerGroup/get-all",
    );

    if (res && res?.success) {
      const getData = res.data;
      setDataWarrantyCustomerGroup(getData);
    }
  };

  const modalCustMeeting = () => {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Thông tin khách hàng </Title>
        </>
      ),
      size: "auto",
      children: (
        <Tabs defaultValue="gallery">
          <Tabs.List>
            <Tabs.Tab value="gallery" leftSection={<IconUser size={14} />}>
              Thông tin khách hàng hẹn gặp
            </Tabs.Tab>
            <Tabs.Tab
              value="messages"
              leftSection={<IconUserQuestion size={14} />}
            >
              Thông tin khách hàng đến bảo hành
            </Tabs.Tab>
          </Tabs.List>
          <Tabs.Panel value="gallery">
            <CustMeeting
              setDataMeetingAddress={setDataMeetingAddress}
              infoCust={form.setValues}
              setOldAddress={setOldAddress}
              view={"CREATE"}
            />
          </Tabs.Panel>
          <Tabs.Panel value="messages">
            <ListCustMeetingInfomation
              setDataMeetingAddress={setDataMeetingAddress}
              infoCust={form.setValues}
              view={"CREATE"}
            />
          </Tabs.Panel>
        </Tabs>
      ),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const handleSearchByPhone = (type: string) => {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Danh sách hóa đơn</Title>
        </>
      ),
      children: (
        <Box mt={"18px"}>
          <WarrantyItem
            custId={form.getValues().custId ?? ""}
            selectWarrantyItem={setDataWarrantyItem}
            setFormValues={form.setValues}
            type={type}
          />
        </Box>
      ),
      size: "auto",
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const callApiGetData = async () => {
    open();
    const callApi = await repositoryMdm.get<
      MessageResponse<TblWarrantyServiceRequestForm>
    >("/api/v1/TblWarrantyServiceRequestForm/create?prefix=PYCXL");
    if (callApi?.success) {
      const dataApi = callApi?.data;
      if (dataApi !== null) {
        await Promise.all([
          processingMethodSelect(),
          saleChannelSelect(),
          getDataProvinceSelect(),
          getDataWarrantyCustomerGroup(),
        ]);
        form.setValues({
          ...dataApi,
          meetingDate: new Date()?.toISOString(),
          createDate: new Date()?.toISOString(),
        });
      }
      close();
    }
  };

  const handleCreateTblWarrantyServiceRequestForm = async (
    dataSubmit: TblWarrantyServiceRequestForm,
  ) => {
    open();

    if (
      dataWarrantyItemSubmit.some(
        (item) => item.serviceType === null || item.itemCode === null,
      )
    ) {
      NotificationExtension.Fails(
        "Vui lòng nhập đầy đủ thông tin cho từng sản phẩm !",
      );
      close();
      return;
    }

    if (dataWarrantyItemSubmit.length > 0) {
      const dataItemSubmit = dataWarrantyItemSubmit.map((item) => ({
        id: 0,
        requestFormId: 0,
        serial: item.serial?.toString()?.trim() ?? null,
        parentSerial: item.parentSerial ?? null,
        orderId: item.orderId ?? null,
        orderCode: item.orderCode ?? null,
        handleDate: null,
        conclusionError: null,
        resolution: null,
        technicalFeedback: null,
        scheduleTime: null,
        brandId: null,
        empBrand: null,
        phoneBrand: null,
        addressBrand: null,
        noteBrand: null,
        po: null,
        itemId: item.itemId ?? 0,
        empCall: null,
        dateCall: null,
        deadline: null,
        buyingDate: item.buyingDate ?? null,
        warrantyTerm: item.warrantyTerm ?? null,
        serviceType: item.serviceType ?? null,
        entryDate: null,
        attribute1: item.attribute1 ?? null,
        attribute5: item.attribute5 ?? null,
        attribute3: item.attribute3 ?? null,
        attribute4: item.attribute4 ?? null,
        customerOrderId: item.customerOrderId ?? null,
      }));
      dataSubmit = {
        ...dataSubmit,
        tblWarrantyServiceRequestFormDetailCommands: dataItemSubmit,
      };
    } else {
      NotificationExtension.Warn(
        "Vui lòng chọn sản phẩm bảo hành từ hóa đơn mua hàng.",
      );
      close();
      return;
    }

    const dataApi = await repositoryMdm.post<
      MessageResponse<TblWarrantyServiceRequestForm>
    >("/api/v1/TblWarrantyServiceRequestForm/create", dataSubmit);
    if (dataApi?.success) {
      NotificationExtension.Success("Lập phiếu tiếp nhận yêu cầu thành công !");
      setTimeout(() => {
        onSuccess((prev: any) => !prev);
        onClose("");
      }, 1500);
    }
    close();
  };

  async function getDataProvinceSelect() {
    const getData = await getProvinceSelectNew();
    setDataProvinceSelect(
      getData
        ?.filter((item: any) => item.id != null && item.name != null)
        ?.map((item: any) => ({
          value: String(item.id),
          label: String(item.name),
        })),
    );
  }

  const getDataCommuneSelect = async () => {
    const currentProvince = dataMeetingAddress.province;
    if (currentProvince) {
      const getData = await getCommuneSelectNew(String(currentProvince));
      const mapped =
        getData
          ?.filter((item: any) => item.value != null && item.text != null)
          ?.map((item: any) => ({
            value: String(item.value),
            label: String(item.text),
          })) ?? [];
      setDataCommuneSelect(mapped);

      // Phường/Xã lấy từ dữ liệu cũ có thể không map được sang dữ liệu API mới
      // -> nếu value không tìm thấy label trong danh sách vừa tải thì reset về null
      setDataMeetingAddress((prev: any) => {
        const commune = prev.commune;
        const isValid =
          commune === null ||
          commune === undefined ||
          mapped.some((item: any) => String(item.value) === String(commune));
        return isValid ? prev : { ...prev, commune: null };
      });
    }
  };

  const fetchDataListTelephone = async () => {
    const response = await repositoryMdm.get<
      MessageResponse<TblWarrantyReceipt>
    >(
      `/api/v1/TblWarrantyReceipt/create?phoneNumber=${
        form.getValues().custPhone || handleOnChangeNumber
      }`,
    );

    if (response && response.success) {
      const result = response.data ?? {};
      const allValuesNullOrZero = Object.values(result).every(
        (val) => val === null || val === 0,
      );
      if (!allValuesNullOrZero) {
        setDataMeetingAddress((prev: any) => ({
          ...prev,
          custMeeting: result.customerName,
          province: Number(result.provinceId),
          // custPhone: result.phoneNumber ?? "",
          commune: Number(result.communeId),
          additionalAddress: result.address,
        }));

        form.setValues((prev) => ({
          ...prev,
          additionalAddress: result.address ?? "",
          content: result.errorNote ?? "",
          custMeeting: result.customerName,
          // custPhone: result.phoneNumber ?? "",
          province: Number(result.provinceId),
          commune: Number(result.communeId),
          custAddress: result.address,
        }));
      } else {
        NotificationExtension.Warn("Không tìm thấy khách hàng!");
      }
    }
  };

  useEffect(() => {
    callApiGetData();
  }, []);

  useEffect(() => {
    if (dataMeetingAddress.province) {
      getDataCommuneSelect();
    }
  }, [dataMeetingAddress.province]);

  // Tỉnh/TP lấy từ dữ liệu cũ có thể không map được sang dữ liệu API mới
  // -> nếu value không tìm thấy label thì reset Tỉnh/TP và Phường/Xã về null
  useEffect(() => {
    if (
      dataProvinceSelect.length > 0 &&
      dataMeetingAddress.province !== null &&
      dataMeetingAddress.province !== undefined
    ) {
      const isProvinceValid = dataProvinceSelect.some(
        (item) => String(item.value) === String(dataMeetingAddress.province),
      );
      if (!isProvinceValid) {
        setDataMeetingAddress((prev: any) => ({
          ...prev,
          province: null,
          commune: null,
        }));
      }
    }
  }, [dataProvinceSelect, dataMeetingAddress.province]);

  useEffect(() => {
    if (dataMeetingAddress.province !== null) {
      const toAddress = `${getValueById(
        dataMeetingAddress.commune?.toString() ?? "",
        dataCommuneSelect,
        "label",
      )} - ${getValueById(
        dataMeetingAddress.province?.toString(),
        dataProvinceSelect,
        "label",
      )}`;
      form.setValues((prev) => ({
        ...prev,
        meetingAddress: toAddress
          .replace(/\s*-\s*-\s*/g, " - ")
          .replace(/^\s*-\s*/, ""),
      }));
    }
    form.setValues((prev) => ({
      ...prev,
      branchId: JSON.parse(localStorage.getItem("userLoginHeader") || "{}")
        ?.branchId,
      // branchId: 221,
      isReceive: false,
      communeId: Number(dataMeetingAddress.commune),
      provinceId: Number(dataMeetingAddress.province),
    }));
  }, [dataMeetingAddress, dataProvinceSelect, dataCommuneSelect]);

  useEffect(() => {
    const seenSerials = new Set();
    const uniqueData = dataWarrantyItem.filter((item) => {
      if (seenSerials.has(item.serial)) {
        return false;
      }
      seenSerials.add(item.serial);
      return true;
    });
    setDataWarrantyItem(uniqueData);
  }, [dataWarrantyItem]);

  useEffect(() => {
    if (
      new Date(form.getValues().createDate ?? "") >
      new Date(form.getValues().meetingDate ?? "")
    ) {
      form.setValues((prev) => ({ ...prev, meetingDate: null }));
    }
  }, [form.getValues().createDate]);

  useEffect(() => {
    if (dataWarrantyItem?.length === 0) {
      form.setValues((prev) => ({
        ...prev,
        attribute6: null,
      }));
    }
  }, [dataWarrantyItem]);

  useEffect(() => {
    if (
      form.getValues()?.attribute8 === "LCN" &&
      form.getValues()?.customerGroup !== null
    ) {
      form.setValues((prev) => ({
        ...prev,
        custMeeting: getValueById(
          form.getValues()?.customerGroup?.toString() ?? "",
          dataWarrantyCustomerGroup,
          "text",
        ),
        custPhone: getValueById(
          form.getValues()?.customerGroup?.toString() ?? "",
          dataWarrantyCustomerGroup,
          "attribute6",
        ),
        additionalAddress: getValueById(
          form.getValues()?.customerGroup?.toString() ?? "",
          dataWarrantyCustomerGroup,
          "attribute5",
        ),
      }));
      handleOnChange(
        getValueById(
          form.getValues()?.customerGroup?.toString() ?? "",
          dataWarrantyCustomerGroup,
          "text",
        ),
        "custMeeting",
      );
      handleOnChange(
        getValueById(
          form.getValues()?.customerGroup?.toString() ?? "",
          dataWarrantyCustomerGroup,
          "attribute6",
        ),
        "custPhone",
      );
      handleOnChange(
        getValueById(
          form.getValues()?.customerGroup?.toString() ?? "",
          dataWarrantyCustomerGroup,
          "attribute1",
        ),
        "province",
      );
      handleOnChange(
        getValueById(
          form.getValues()?.customerGroup?.toString() ?? "",
          dataWarrantyCustomerGroup,
          "attribute3",
        ),
        "commune",
      );
      handleOnChange(
        getValueById(
          form.getValues()?.customerGroup?.toString() ?? "",
          dataWarrantyCustomerGroup,
          "attribute5",
        ),
        "additionalAddress",
      );
    }
  }, [form.getValues()?.customerGroup, form.getValues()?.attribute8]);

  useEffect(() => {
    if (
      dataTblSaleChannel.length > 0 ||
      dataWarrantyCustomerGroup.length > 0 ||
      dataTblProcessingMethod.length > 0
    ) {
      form.setValues(
        (prev) =>
          ({
            ...prev,
            channel: "67",
            processingMethod: "XLCN",
            customerGroup: "BHKL",
            attribute8: getValueById(
              "BHKL",
              dataWarrantyCustomerGroup,
              "attribute7",
            ),
          }) as TblWarrantyServiceRequestForm,
      );
    }
  }, [dataTblSaleChannel, dataTblProcessingMethod]);

  useEffect(() => {
    if (dataMeetingAddress.content) {
      form.setValues((prev) => ({
        ...prev,
        content: dataMeetingAddress.content,
      }));
    }
  }, [dataMeetingAddress.content]);

  return (
    <>
      <Box
        component="form"
        mx="auto"
        mt={-7.5}
        p={"0px 10px"}
        onSubmit={form.onSubmit((e: TblWarrantyServiceRequestForm) => {
          handleCreateTblWarrantyServiceRequestForm(e);
        })}
        style={{ position: "relative" }}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />
        <Flex justify={"space-between"} align={"center"}>
          <Badge
            variant="gradient"
            gradient={{ from: "blue", to: "cyan", deg: 90 }}
          >
            Lập phiếu tiếp nhận yêu cầu
          </Badge>
          <Group
            justify="space-between"
            align="center"
            style={{
              position: "sticky",
              bottom: 0,
              backgroundColor: "white",
            }}
          >
            <Flex w={"100%"} justify={"flex-end"} gap={"md"}>
              <Button
                type="button"
                color="red"
                loading={visible}
                onClick={() => {
                  onClose("");
                }}
                leftSection={!visible ? <IconArrowBack size={18} /> : undefined}
              >
                Thoát
              </Button>
              <Button
                type="submit"
                color="teal"
                loading={visible}
                leftSection={!visible ? <IconCheck size={18} /> : undefined}
              >
                Lưu
              </Button>
            </Flex>
          </Group>
        </Flex>
        <Grid>
          <Grid.Col span={{ base: 12, md: 12, lg: 5.5 }}>
            <Fieldset legend="Thông tin yêu cầu xử lý">
              <Grid>
                <Grid.Col span={{ base: 12, md: 4, lg: 4 }}>
                  <TextInput
                    label="Chi nhánh xử lý yêu cầu"
                    value={
                      JSON.parse(localStorage.getItem("userLoginHeader") ?? "")
                        ?.brachName
                    }
                    variant="filled"
                    readOnly
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 4, lg: 4 }}>
                  <DateTimePicker
                    label="Ngày tiếp nhận"
                    locale="vi"
                    valueFormat="DD-MM-YYYY hh:mm A"
                    minDate={(() => {
                      const date = new Date();
                      date.setMonth(date.getMonth() - 1);
                      date.setDate(1);
                      return date;
                    })()}
                    value={
                      form.getValues().createDate
                        ? new Date(form.getValues()?.createDate ?? "")
                        : null
                    }
                    onChange={(e) =>
                      form.setValues((prev) => ({
                        ...prev,
                        createDate: e ? new Date(e ?? "")?.toISOString() : null,
                      }))
                    }
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 4, lg: 4 }}>
                  <TextInput
                    label="Người tiếp nhận yêu cầu"
                    readOnly
                    value={
                      JSON.parse(
                        localStorage.getItem("userLoginHeader") || "{}",
                      )?.fullname || ""
                    }
                    {...form.getInputProps("createBy")}
                    variant="filled"
                  />
                </Grid.Col>
              </Grid>
              <Grid>
                <Grid.Col span={{ base: 12, md: 4, lg: 4 }}>
                  <TextInput
                    label="Mã phiếu tiếp nhận yêu cầu"
                    readOnly
                    variant="filled"
                    {...form.getInputProps("requestNum")}
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 4, lg: 4 }}>
                  <Select
                    label="Kênh tiếp nhận"
                    placeholder="Chọn kênh tiếp nhận"
                    clearable
                    searchable
                    value={
                      form.getValues().channel ? form.getValues().channel : ""
                    }
                    data={dataTblSaleChannel}
                    {...form.getInputProps("channel")}
                    comboboxProps={{ width: 210 }}
                    withAsterisk
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 4, lg: 4 }}>
                  <Select
                    label="Hình thức xử lý"
                    clearable
                    searchable
                    value={
                      form.getValues().processingMethod
                        ? form.getValues().processingMethod
                        : ""
                    }
                    placeholder="Chọn hình thức xử lý"
                    data={dataTblProcessingMethod}
                    {...form.getInputProps("processingMethod")}
                    onChange={(e) => {
                      form.setValues((prev) => ({
                        ...prev,
                        processingMethod: e ? e?.toString() : null,
                      }));
                    }}
                    withAsterisk
                  />
                </Grid.Col>
              </Grid>
              <Grid>
                <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
                  <TextInput
                    label="Số phiếu tiếp nhận yêu cầu"
                    placeholder="Số phiếu tiếp nhận yêu cầu"
                    type="number"
                    {...form.getInputProps("attribute10")}
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
                  <Select
                    label="Nhóm khách hàng"
                    placeholder="Nhập nhóm khách hàng"
                    data={dataWarrantyCustomerGroup
                      ?.filter(
                        (item: any) =>
                          item.text !== null && item.value !== null,
                      )
                      ?.map((item: any) => ({
                        label: item.text,
                        value: item.value?.toString(),
                      }))}
                    value={form.getValues().customerGroup?.toString() ?? null}
                    searchable
                    {...form.getInputProps("customerGroup")}
                    onChange={(value) => {
                      form.setValues((prev) => ({
                        ...prev,
                        customerGroup: value ? value : null,
                        attribute8: getValueById(
                          value?.toString() ?? "",
                          dataWarrantyCustomerGroup,
                          "attribute7",
                        ),
                      }));
                    }}
                    withAsterisk
                  />
                </Grid.Col>
              </Grid>
            </Fieldset>
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 12, lg: 6.5 }}>
            <Fieldset legend="Thông tin khách hàng hẹn gặp">
              <Grid>
                <Grid.Col span={{ base: 12, md: 6, lg: 4 }}>
                  <TextInput
                    label="Người hẹn gặp"
                    placeholder={"Nhập người hẹn gặp"}
                    value={dataMeetingAddress.custMeeting || ""}
                    {...form.getInputProps("custMeeting")}
                    onDoubleClick={() => {
                      // Nhóm khách hàng LCN thì không cho chọn lại Người hẹn gặp
                      if (form.getValues().attribute8 === "LCN") return;
                      modalCustMeeting();
                    }}
                    onChange={(e) => {
                      const value = e.target.value;
                      setOldAddress(null);
                      setDataMeetingAddress((prev: any) => ({
                        ...prev,
                        custMeeting: value,
                      }));
                      form.setFieldValue("custMeeting", value);
                    }}
                    withAsterisk
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 6, lg: 4 }}>
                  <TextInput
                    label="Số điện thoại"
                    value={dataMeetingAddress.custPhone || ""}
                    placeholder={"Nhập số điện thoại"}
                    {...form.getInputProps("custPhone")}
                    onKeyPress={(e) => {
                      if (
                        !/[0-9]/.test(e.key) &&
                        e.key !== "Backspace" &&
                        e.key !== "Delete" &&
                        e.key !== "ArrowLeft" &&
                        e.key !== "ArrowRight"
                      ) {
                        e.preventDefault();
                      }
                    }}
                    rightSection={
                      <ActionIcon
                        disabled={
                          isPhoneInvalid ||
                          form.getValues().attribute8 === "LCN"
                        }
                        bd="1px solid blue"
                        onClick={fetchDataListTelephone}
                        color="blue"
                        variant="light"
                        aria-label="Settings"
                      >
                        <IconSend
                          style={{ width: "70%", height: "70%" }}
                          stroke={1.5}
                        />
                      </ActionIcon>
                    }
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, "");
                      setOldAddress(null);
                      setHandleOnChangeNumber(value);
                      setDataMeetingAddress((prev: any) => ({
                        ...prev,
                        custPhone: value,
                      }));
                      form.setFieldValue("custPhone", value);
                    }}
                    type="number"
                    withAsterisk
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 6, lg: 4 }}>
                  <DateTimePicker
                    label="Ngày hẹn gặp"
                    placeholder="Nhập ngày hẹn gặp"
                    locale="vi"
                    valueFormat="DD-MM-YYYY hh:mm A"
                    minDate={new Date(form.getValues().createDate ?? "")}
                    value={
                      form.getValues().meetingDate
                        ? new Date(form.getValues().meetingDate ?? "")
                        : null
                    }
                    {...form.getInputProps("meetingDate")}
                    onChange={(e) =>
                      form.setValues((prev) => ({
                        ...prev,
                        meetingDate: e ? new Date(e ?? "").toISOString() : null,
                      }))
                    }
                    withAsterisk
                  />
                </Grid.Col>
              </Grid>
              <Grid>
                <Grid.Col span={{ base: 12, md: 6, lg: 4 }}>
                  <Select
                    label="Tỉnh/TP"
                    placeholder="Nhập tỉnh/thành phố"
                    data={dataProvinceSelect}
                    // disabled={form.getValues().attribute8 === "LCN"}
                    value={
                      dataMeetingAddress.province
                        ? dataMeetingAddress?.province?.toString()
                        : null
                    }
                    searchable
                    clearable
                    nothingFoundMessage="Không tìm thấy dữ liệu !"
                    variant={
                      form.getValues().attribute8 === "LCN"
                        ? "filled"
                        : "default"
                    }
                    readOnly={form.getValues().attribute8 === "LCN"}
                    withAsterisk
                    {...form.getInputProps("provinceId")}
                    onChange={(e) => {
                      handleOnChange(e, "province");
                      handleOnChange(null, "commune");
                    }}
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 6, lg: 4 }}>
                  <Select
                    key={dataMeetingAddress.commune}
                    label="Phường/Xã"
                    placeholder="Nhập phường/xã"
                    data={dataCommuneSelect}
                    value={
                      dataMeetingAddress.commune
                        ? dataMeetingAddress.commune?.toString()
                        : null
                    }
                    searchable
                    clearable
                    disabled={
                      !dataMeetingAddress.province ||
                      String(dataMeetingAddress.province).length === 0
                    }
                    variant={
                      form.getValues().attribute8 === "LCN"
                        ? "filled"
                        : "default"
                    }
                    readOnly={form.getValues().attribute8 === "LCN"}
                    nothingFoundMessage="Không tìm thấy dữ liệu !"
                    withAsterisk
                    {...form.getInputProps("communeId")}
                    onChange={(e) => {
                      handleOnChange(e, "commune");
                    }}
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 6, lg: 4 }}>
                  <TextInput
                    label="Địa chỉ cụ thể"
                    placeholder="Nhập địa chỉ cụ thể"
                    value={dataMeetingAddress.additionalAddress || ""}
                    variant={
                      form.getValues().attribute8 === "LCN"
                        ? "filled"
                        : "default"
                    }
                    readOnly={form.getValues().attribute8 === "LCN"}
                    {...form.getInputProps("additionalAddress")}
                    onChange={(e) =>
                      setDataMeetingAddress((prev: any) => ({
                        ...prev,
                        additionalAddress: e.target.value,
                      }))
                    }
                  />
                </Grid.Col>
              </Grid>
              <Grid>
                <Grid.Col span={12}>
                  <TextInput
                    label="Nội dung"
                    value={dataMeetingAddress.content || ""}
                    placeholder={"Nhập nội dung"}
                    {...form.getInputProps("content")}
                    onChange={(e) =>
                      setDataMeetingAddress((prev: any) => ({
                        ...prev,
                        content: e.target.value,
                      }))
                    }
                  />
                </Grid.Col>
              </Grid>
            </Fieldset>
          </Grid.Col>
        </Grid>
        {oldAddress && (
          <Box
            mt={8}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              padding: "8px 14px",
              borderRadius: 8,
              borderLeft: "3px solid var(--mantine-color-orange-5)",
              backgroundColor: "var(--mantine-color-orange-0)",
            }}
          >
            <IconMapPin
              size={18}
              stroke={1.5}
              style={{
                flexShrink: 0,
                color: "var(--mantine-color-orange-6)",
              }}
            />
            <Text size="sm" c="dimmed">
              <Text span fw={600} c="orange.7">
                Địa chỉ khách hàng hẹn gặp trước sát nhập:{" "}
              </Text>
              {oldAddress}
            </Text>
          </Box>
        )}
        <Grid mt={10}>
          <Grid.Col span={12}>
            <ItemList
              handleSearchByPhone={handleSearchByPhone}
              onSelect={setDataWarrantyItemSubmit}
              dataItem={dataWarrantyItem}
              setDataWarrantyItem={setDataWarrantyItem}
              onDelete={setDataWarrantyItem}
              setFormValues={form.setValues}
              typeProduct={form.getValues()?.attribute6}
            />
          </Grid.Col>
        </Grid>
      </Box>
    </>
  );
};

export default CreateDataView;

type CreateDataViewProps = {
  onClose: any;
  onSuccess: any;
};
